import Badge from "./badge";
import React from "react";

export default function BadgeLegend({ children, color, ghost, icon, text }) {
  return (
    <dl className="tournament-table_badges">
      <dt>
        <Badge color={color} ghost={ghost} icon={icon} text={text} />
      </dt>

      <dd>
        {children}
      </dd>
    </dl>
  );
}
